import React from 'react';

const SvgBaselineKeyboardArrowUp = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
  </svg>
);

export default SvgBaselineKeyboardArrowUp;
